<script>
import PickupEditForm from '@/components/Application/CustomerService/Pickups/Pickup/EditForm'

export default {
  extends: PickupEditForm
}
</script>
